<template>
    <zen-one
        :showuserinfo="false"
        title="Cukai Tanah:: Sejarah Bayaran"
        :crumbs="crumbs"
    >
        <z-page :title="`Sejarah Bayaran`" :append-button="true">
            <w-flex column :gap="3">
                <w-form @submit.prevent="filter">
                    <w-flex column :gap="3">
                        <w-flex :columns="{ xs: 1 }" :gap="3">
                            <w-input v-model="searchParams.no_hm"
                                >No. HM</w-input
                            >
                            <w-button
                                :loading="loading"
                                class="align-self-end"
                                type="submit"
                            >
                                SEMAK
                            </w-button>
                        </w-flex>
                    </w-flex>
                </w-form>

                <Table
                    :headers="sejBayar.headers"
                    :items="loading ? [] : sejBayar.items"
                    :loading="loading"
                >
                </Table>
            </w-flex>
        </z-page>
    </zen-one>
</template>

<script>
import moment from "moment";
import ZResource from "@/Modules/z-resource";
import Table from "../Component/Table";
import TablePagination from "../Component/TablePagination";

export default {
    extends: ZResource,
    components: { Table, TablePagination},
    data() {
        return {
            resourceurl: "cukai-tanah",
            apiBaseUrl: process.env.MIX_API_BASE_URL,
            reload: true,
            loading: false,
            crumbs: [
                { label: this.$page.props.app_name, route: "/sitemap" },
                { label: "Cukai Tanah", route: "/cukai-tanah/dashboard" },
                { label: "Sejarah Bayaran", route: "/cukai-tanah/sejarahBayaran" },
            ],
            total: 0,
            pagination: {
                perPage: 10,
                currentPage: 1,
                lastPage: 1,
            },

            sejBayar: {
                headers: [
                    { label: "Cara Bayar",     key: "cara_bayar" },
                    { label: "No Resit",     key: "no_resit" },
                    { label: "Tarikh bayar", key: "tarikh_bayar" },
                    { label: "No Rujukan",     key: "no_rujukan" },
                    { label: "Amaun",     key: "amaun" },
                    { label: "Tarikh Batal",    key: "tarikh_batal" },
                    // { label: "Pembayar",      key: "pembayar"  },
                    // { label: "Kerani",      key: "kerani"  },
                    { label: "Status",   key: "status"},
                ],
                items: [
                    {
                    cara_bayar : null,
                    no_resit : null,
                    tarikh_bayar:null,
                    no_rujukan:null,
                    amaun:null,
                    tarikh_batal:null,
                    // kerani:null,
                    status:null,
                    }
                ],
            },
            searchParams: {
                no_hm: null,
            },
            dialog:{
                show: false
            },
            searching: false,
            hasSearched: false,
            hm:[]
        };
    },
    methods: {
        moment(date) {
            return moment(date);
        },
        onPaginationChange(e) {
            this.pagination.currentPage = e.value.currentPage;
            this.pagination.perPage = e.value.perPage;
            this.fetchData2();
        },
        filter() {
            this.searchParams.status =
                this.searchParams.status === "null"
                    ? null
                    : this.searchParams.status;
            this.fetchData2();
        },
        async fetchData2() {
            this.loading = true;
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/cukai/sejarahBayaran`,
                params: this.searchParams,
                responseType: "json",
            }).then((e) => {
                console.log(e.data);
                // this.sejBayar.items = e.data;
                this.sejBayar.items = e.data.map((e) => {
                        return {
                            cara_bayar:e.cara_bayar.keterangan,
                            no_resit:e.no_resit,
                            tarikh_bayar:e. tarikh_bayar,
                            no_rujukan:e.no_rujukan,
                            amaun:e.amaun,
                            tarikh_batal:e.tarikh_batal,
                            // kerani:e.user[0].no_id,
                            status:e.status.keterangan,
                        };
                });
            
            });

            this.loading = false;
        },

    },

};
</script>
